import client from './client';

export const uploadVideoChunk = async (formData) => {
  try {
    const res = await client.post('/api/upload-chunk', formData);
    return res.data;
  } catch (err) {
    console.error('[UploadChunk Failed]', err.message, err.response?.data || '');
  }
};
